import { render, staticRenderFns } from "./ControlMenu.vue?vue&type=template&id=23c72c04&scoped=true&"
import script from "./ControlMenu.vue?vue&type=script&lang=js&"
export * from "./ControlMenu.vue?vue&type=script&lang=js&"
import style0 from "./ControlMenu.vue?vue&type=style&index=0&id=23c72c04&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c72c04",
  null
  
)

export default component.exports